import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../infrastructure/redux/store';
import { Button } from '../button';

import { Body, Center, Container, Footer, Header, Message, Title } from './styles';

export interface ModalProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ModalConfirm: React.FC<ModalProps> = (props) => {
  const { theme } = useSelector((state: RootState) => state.theme);

  return (
    <Center onClick={props.onCancel}>
      <Container onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>{props.title}</Title>
        </Header>
        <Body>
          <Message>{props.message}</Message>
        </Body>
        <Footer>
          <Button color={theme.colors.background} onClick={props.onCancel}>
            Cancelar
          </Button>
          <Button color={theme.colors.error} onClick={props.onConfirm}>
            Deletar
          </Button>
        </Footer>
      </Container>
    </Center>
  );
};

export { ModalConfirm };
